import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditorToolbar, { formats, modules } from "./EditorToolbar";

import { useLocation, useNavigate } from "react-router-dom";
import { updatePost } from "../../../feature/posts/postSlice";
import "./editBlog.scss";

const EditBlog = () => {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [imgUrl, setImgUrl] = useState(null);
  const [body, setBody] = useState({ value: null });
  const [id, setId] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { title, image, body, _id } = location.state;
    setTitle(title);
    setImgUrl(image);
    setBody({ value: body.value });
    setId(_id);
  }, [location.state]);

  const handleImgUpload = () => {
    const myData = new FormData();
    myData.append("file", image);
    myData.append("upload_preset", "portfolio");
    myData.append("cloud_name", "djwncpbir");

    fetch("https://api.cloudinary.com/v1_1/djwncpbir/image/upload", {
      method: "post",
      body: myData,
    })
      .then((res) => res.json())
      .then((data) => setImgUrl(data.url))
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    dispatch(updatePost({ title, image: imgUrl, body, id }));
    setTitle("");
    setImage("");
    setBody({ value: null });
    toast.success("Post Update successfully", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "dark",
      pauseOnHover: true,
      draggable: true,
      Limit: 1,
    });
    setTimeout(() => {
      navigate("/dashboard/all_posts", { replace: true });
    }, 2000);
  };

  return (
    <div className="create-blog-container">
      <h2>Update Blog Post: </h2>
      <div className="inp-blog">
        <form onSubmit={handleUpdate}>
          <input
            className="title common-input"
            type="text"
            name="title"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            placeholder="Title Of Blog Post"
          />
          <br />
          <div className="file-inp">
            <input
              type="file"
              name="image"
              onChange={(e) => setImage(e.target.files[0])}
            />
            <Button className="img-btn" onClick={handleImgUpload}>
              Upload
            </Button>
          </div>
          <div className="text-editor">
            <EditorToolbar />
            <ReactQuill
              className="text-aria"
              theme="snow"
              value={body.value}
              onChange={(value) => setBody({ value })}
              placeholder={"Write Your Blog..."}
              modules={modules}
              formats={formats}
            />
          </div>
          <Button className="submit-btn" type="submit">
            Update
          </Button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default EditBlog;
